import { TextTypes } from '@genial/components';
import { Utils, useBreakpointValue } from '@genial/utils';
import { useRecoilValue } from 'recoil';

import { basketCustomerOrderResumeState } from '../../../store/batchTicket/atom';
import {
  totalAmountBasketOffersResumeSelector,
  totalAvailableBalanceBasketOrderResumeSelector,
  totalCustomerBasketOrderResumeSelector,
  totalOffersBasketOrderResumeSelector,
  totalOffersByMarketBasketOrderResumeSelector,
} from '../../../store/batchTicket/selectors';

export const useBasketInfoResume = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  const { summary } = useRecoilValue(basketCustomerOrderResumeState);
  const totalCustomers = useRecoilValue(totalCustomerBasketOrderResumeSelector);
  const totalOffersByMarket = useRecoilValue(totalOffersByMarketBasketOrderResumeSelector);
  const totalAmountFormatted = useRecoilValue(totalAmountBasketOffersResumeSelector).formatted;
  const totalOffers = useRecoilValue(totalOffersBasketOrderResumeSelector);
  const totalAvailableBalanceFormatted = useRecoilValue(
    totalAvailableBalanceBasketOrderResumeSelector
  ).formatted;

  const updatedDateFormatted = `Atualizado em ${Utils.Mask.DateFormat(
    summary.updateDate || new Date(),
    'dd/MM HH:mm:ss'
  )}`;

  const fontVariant: TextTypes.Variant = isMobile ? 'regular' : 'semibold';

  return {
    fontVariant,
    isMobile,
    totalCustomers,
    totalOffers,
    totalAmountFormatted,
    totalAvailableBalanceFormatted,
    updatedDateFormatted,
    totalOffersByMarket,
  };
};
